import { useUserRoles } from 'modules/app/hooks/useUserRoles';

export const useCanAccessCompanySettings = (): boolean => {
  const { isAccountOwner, isAdmin } = useUserRoles();
  return isAccountOwner || isAdmin;
};
